export const COPY_MODAL_TEST_ID = 'copy-template-modal';

export const RADIO_OPTIONS = {
  UNSELECTED: 'unselected',
  CURRENT_PROJECT: 'current project',
  ANOTHER_PROJECT: 'another project',
};

export const COPY_MODAL_DISPLAY_CONTENT = {
  modalHeader: 'Copy template',
  templateNameInput: { label: 'New template name' },
  copyTemplateButtonText: 'Copy template',
  radio: {
    header: 'Save to',
    curProjText: 'Current project',
    otherProjText: 'Another project',
  },
  selects: {
    project: {
      title: 'Project name',
      placeholder: 'Select project',
      empty: 'No other projects',
    },
    messageType: {
      title: 'Message type',
      placeholder: 'Select message type',
      empty: 'No message types exist in this project',
    },
    sender: {
      title: 'Sender',
      placeholder: 'Select sender',
      empty: 'No senders exist in this project',
    },
  },
};
